import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme/constants';
export var ErrorMessageContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-left: ", "px;\n"])), function (props) {
  return props.isSearch ? gridSize() : 0;
});
export var ErrorMessageList = styled.ul(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding-left: ", "px;\n"])), gridSize() * 3);